import Header from './Header'
import Card from './Card'
import Corkboard from './Corkboard'
import MissionCard from './MissionCard'
import Chalkboard from './Chalkboard'
import EmailCard from './EmailCard'
import Interactive from './Interactive'

import Nelson from './Nelson'

import InteractivesArea from './InteractivesArea'
import { useState, useEffect } from 'react'

const Environment = ({ onScreenUpdate }) => {
  const [dialogue, setDialogue] = useState(null)
  const [showDialogue, setShowDialogue] = useState(false)
  const [learnLink, setLearnLink] = useState(null)
  const dialogueLinkText = 'Learn More'

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="mainContainer">
      <audio id="umbrella" src="audio/environment/umbrella.mp3" />
      <audio id="scale" src="audio/environment/scale.mp3" />
      <audio id="seed" src="audio/environment/seed_small.mp3" />

      <Header onScreenUpdate={onScreenUpdate} />
      <div className="chalkAndIconsAndCork">
        <div className="chalkAndIcons">
          <Chalkboard>
            <div className="chalkboardHeader LithosPro environmentHeader">
              Horses &amp; the Environment
            </div>
            <div className="chalkboardContent">
              <p>
                Do you eat for 16 hours a day? Some horses do. Horse farmers
                need help growing lots of nutritious grass with few chemicals,
                weeds, and poisonous plants. And what about all the{' '}
                <span className="horsepoop">horse poop</span>?
              </p>
              <p>
                Neighbors don't like the smell, and rain water flowing through
                farms can pollute streams.
              </p>
              <p>
                Get the 'Scoop on Poop' and learn how to keep horse farms
                friendly to the environment by clicking around.
              </p>
            </div>
          </Chalkboard>
          <InteractivesArea>
            <Interactive
              cat={'environment'}
              itemName={'umbrella'}
              alt={'opened upside down umbrella'}
              url={'envirFAQ.html'}
              sound={'umbrella'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div className="dialogue">
                    <p>Ever see a muddy stream after a rainstorm?</p>
                    <p>Whatever was on the land is now rushing downstream.</p>
                    <p>
                      Equine science helps slow down, direct, catch, and clean
                      water on horse farms.
                    </p>
                  </div>
                )
                setLearnLink('pages/environment/envirFAQ.html')
              }}
            />
            <Interactive
              cat={'environment'}
              itemName={'scale'}
              alt={'electronic scale'}
              url={'scoopOnPoop.html'}
              sound={'scale'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>
                      We eat and drink a lot, and so we poop a lot -- about 50
                      pounds of manure each day.
                    </p>
                    <p>
                      Science teaches farmers how to use mature to protect the
                      environment and keep neighbors happy.
                    </p>
                  </div>
                )
                setLearnLink('pages/environment/scoopOnPoop.html')
              }}
            />
            <Interactive
              cat={'environment'}
              itemName={'scoop'}
              alt={'green scoop with horse feed pellets in it'}
              url={'goingGreen.html'}
              sound={'seed'}
              onClick={(speaking) => {
                setShowDialogue(speaking)
                setDialogue(
                  <div>
                    <p>
                      Weeds, thorns, and poisonous plants are not appetizing -
                      or healthy - for a horse.
                    </p>
                    <p>
                      That's why equine scientists research which seeds and
                      farming methods grow the best pasture grasses for horses,
                      while protecting the environment.
                    </p>
                  </div>
                )
                setLearnLink('pages/environment/goingGreen.html')
              }}
            />
          </InteractivesArea>
        </div>
        <Corkboard onScreenUpdate={onScreenUpdate}>
          <MissionCard />
          <EmailCard />

          <Card className="linksCard">
            <div className="cardTitle linksTitle">Links</div>
            <div className="linksLink">
              <a
                href="pages/environment/envirFAQ.html"
                target="_blank"
                rel="noreferrer"
              >
                Environment FAQs
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/environment/scoopOnPoop.html"
                target="_blank"
                rel="noreferrer"
              >
                Scoop on Poop
              </a>
            </div>
            <div className="linksLink">
              <a
                href="pages/environment/goingGreen.html"
                target="_blank"
                rel="noreferrer"
              >
                Going Green
              </a>
            </div>
            <div className="linksLink">
              <a
                href="https://esc.rutgers.edu/research/ryders-lane-farm/"
                target="_blank"
                rel="noreferrer"
              >
                Ryders Lane Farm Virtual Tour
              </a>
            </div>
          </Card>
        </Corkboard>
      </div>
      <Nelson
        showDialogue={showDialogue}
        dialogue={dialogue}
        setShowDialogue={setShowDialogue}
        learnLink={learnLink}
        dialogueLinkText={dialogueLinkText}
      />
    </div>
  )
}

export default Environment
